// extracted by mini-css-extract-plugin
export default {"root":"AuthModal_root__WqDXQ","buttonGroup":"AuthModal_buttonGroup__Vc2UT","backDrop":"AuthModal_backDrop__xqa9G"};